module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'list') ? _c('div', {
    staticClass: "product-counter",
    class: {
      visible: _vm.shoppingState
    }
  }, [_vm._v("\n  " + _vm._s(_vm.numberOfCollectedItems) + " / " + _vm._s(_vm.items.length) + " producten verzameld\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d0ed50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ProductCounter.vue
// module id = 482
// module chunks = 1